document.addEventListener("DOMContentLoaded", function () {
  // Open popup
  document.querySelectorAll(".popup-button").forEach((button) => {
    button.addEventListener("click", function () {
      const popup = document.getElementById("popup-content");
      if (popup) {
        popup.classList.add("active");
        popup.classList.remove("hidden");
       document.body.style.overflow = 'hidden';
      }
    });
  });

  // Close popup (close button)
  document.querySelectorAll(".popup-close").forEach((closeBtn) => {
    closeBtn.addEventListener("click", function () {
      const popup = document.getElementById("popup-content");
      if (popup) {
        popup.classList.remove("active");
        popup.classList.add("hidden");
        document.body.style.overflow = 'auto';
      }
    });
  });

  // Optional: close popup if user clicks outside the inner box
  const popup = document.getElementById("popup-content");
  if (popup) {
    popup.addEventListener("click", function (e) {
      if (e.target === popup) {
        popup.classList.remove("active");
        popup.classList.add("hidden");
        document.body.style.overflow = 'auto';
      }
    });
  }
});
